import { DEVICE_TYPES } from '../../constants/protocol';
import { formatTime } from '../helpers';

/**
 * Program keys for POST /switches/master-control and /blowers/master-control
 * (per-system and location master control). `backendDispatches` adds
 * `commandNumber` and `actionType`. Temperatures are sent in °C.
 *
 * @param {string} program  instantHeat | fanOnly | snowSensor | constantTemp |
 *   windFactor | heatingSchedule | ats | shutOff
 * @param {Object} options
 * @param {number} [options.temp]  instant heat / constant temp, °C
 * @param {*} [options.data]  heatingSchedule: `{ start, end, inputTemp }` (°C); ats: the selections array
 * @param {'ESS'|'TGS'|'TES'} options.deviceType
 * @returns {Object<string, *>|null}  null for a program that sends nothing
 */
export const masterControlPayload = (program, { temp, data, deviceType }) => {
  switch (program) {
    case 'instantHeat':
      return { instant_temp: temp, on_switch: 1 };
    case 'fanOnly':
      return { fan: 1 };
    case 'snowSensor':
      return { snow_enabled: 1 };
    case 'constantTemp':
      return { on_constant: 1, constant_temp: temp };
    case 'windFactor':
      return { wind: 1 };
    case 'heatingSchedule':
      return {
        schedule: {
          startDate: formatTime(data.start),
          endDate: formatTime(data.end),
          threshold: data.inputTemp,
        },
      };
    case 'ats':
      return { EBP: data.indexOf(true) };
    case 'shutOff':
      return {
        on_switch: 0,
        on_constant: 0,
        wind: 0,
        snow_enabled: 0,
        deleteCurrentSchedule: true,
        ...(deviceType !== DEVICE_TYPES.ESS && { fan: 0 }),
      };
    default:
      return null;
  }
};
